import BaseModel from "./BaseModel"
import moment from "moment";

export default class Contact extends BaseModel {

	static entity = 'contacts';
	static route = 'contacts';
	static plural = 'contacts';
	static singular = 'contact';

	static contact_type_accounting = 'Accounting';
	static contact_type_sales = 'Sales';
	static contact_type_territory_manager = 'Territory Manager';
	static contact_type_owner = 'Owner';

	static fields () {
		return {
			id: this.attr(null),
			full_name: this.attr(null),
			first_name: this.attr(null),
			last_name: this.attr(null),
			type: this.attr(null),
			phone: this.attr(null),
			mobile: this.attr(null),
			fax: this.attr(null),
			email: this.attr(null),
			facebook: this.attr(null),
			twitter: this.attr(null),
			website: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null)
		}
	}

	static missingFields(entity) {
		let missing = [];
		let required = ['first_name', 'last_name', 'type', 'phone', 'email'];
		if(!entity || !entity.id) {
			return missing;
		} else {
			required.forEach((field) => {
				if(!entity[field] || entity[field] === '') {
					missing.push(field);
				}
			});
		}
		return missing;
	}

	static isExpired(contact) {
		if(!contact || !contact.id) {
			return false;
		} else if(contact.updated_at) {
			return moment(contact.updated_at).diff(moment(), 'months') >= 6;
		} else if(contact.created_at) {
			return moment(contact.created_at).diff(moment(), 'months') >= 6;
		}
		return true;
	}

	static contactTypes() {
		return [
			Contact.contact_type_accounting,
			Contact.contact_type_sales,
			Contact.contact_type_territory_manager,
			Contact.contact_type_owner,
		];
	}

}
